import _ from 'lodash';

import Constants from '../Constants';
import ImageRegistry from '../ImageRegistry';
import RenderingState from '../RenderingState';
import TopicVizScaling from '../TopicVizScaling';
import StaticTextElement from '../VirtualDom/drawElements/StaticTextElement';
import StaticWordElementsLayer from '../VirtualDom/StaticWordElementsLayer';
import VirtualDom from '../VirtualDom/VirtualDom';

export default function createWordLevel(
  documentDataPoints,
  virtualDom: VirtualDom,
  scaling: TopicVizScaling,
  imageRegistry: ImageRegistry,
  renderingState: RenderingState,
) {
  const scaleFactor = scaling.getScaleFactor();

  const wordElements = [];
  for (const dataPoint of documentDataPoints.filter(
    dataPoint => dataPoint.getSource() === 'word',
  )) {
    const x =
      scaling.xScale(dataPoint.getX()) -
      scaleFactor * Constants.documentPoint.border;
    const y =
      scaling.yScale(dataPoint.getY()) -
      scaleFactor * Constants.documentPoint.border;

    const color = Constants.wordElement.colorByWordLevel[dataPoint.getLevel()];
    const fontSize =
      Constants.wordElement.fontSizeByWodLevel[dataPoint.getLevel()];
    const padding = Constants.wordElement.paddingByLevel[dataPoint.getLevel()];

    const bold = Constants.wordElement.boldByWordLevel[dataPoint.getLevel()];

    let url = null;
    if (dataPoint.hasUrls() && Constants.wordElement.showPicturesForWords) {
      url = dataPoint.getUrls()[0];
    }

    const wordElement = new StaticTextElement({
      text: _.capitalize(dataPoint.getTitle()),
      fontSize: fontSize,
      x: x,
      bold: bold,
      y: y,
      color: color,
      imageRegistry: imageRegistry,
      url: url,
      padding: padding,
      onRequestDraw: () => renderingState.setDirtyBit(true),
      showPanel:
        Constants.wordElement.showPanelByWordLevel[dataPoint.getLevel()],
      panelColor:
        Constants.wordElement.panelColorByWordLevel[dataPoint.getLevel()],
    });
    wordElement.set('clusterId', dataPoint.getClusterId());
    wordElement.set('level', dataPoint.getLevel());
    wordElements.push(wordElement);
  }

  const selection = new StaticWordElementsLayer({
    name: 'wordElements',
    elements: wordElements,
    showAtInitialZoom: true,
  });
  virtualDom.registerLayer(selection);
}
